import { useEffect } from 'react';

/**
 * 窗口大小监听的自定义Hook
 * @param {function} onResize - 窗口大小改变时的回调函数
 * @param {boolean} enabled - 是否启用监听，默认为 true
 */
const useWindowResize = (onResize, enabled = true) => {
    useEffect(() => {
        if (!enabled) return;

        const handleResize = () => {
            onResize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [onResize, enabled]);
};

export default useWindowResize;
